import { asArray } from 'ol/color';
import { Point } from 'ol/geom';
import { Style, Stroke, Fill, Icon, Text, Circle } from 'ol/style';

import arrowIcon from '@/assets/vectors/arrow.svg';
import { getCSSVariable } from '@/utils/theme';

// prettier-ignore
export const MAPS = {
  GOOGLE: {
    name: 'Google',
    label: null,
    types: [
      { key: 'y', name: 'Satellite' },
      { key: 'm', name: 'Roadmap' },
      { key: 'p', name: 'Terrain' },
    ],
  },
  VWORLD: {
    name: 'VWorld',
    label: 'S. Korea Only',
    types: [
      { key: 'Satellite', name: 'Satellite' },
      { key: 'Base',      name: 'Base' },
      { key: 'white',     name: 'White' },
      { key: 'midnight',  name: 'Midnight' },
      { key: '3d',        name: '3D' },
    ],
  },
};

export const STYLES = {
  MISSION: {
    ARROW: (rotation) =>
      new Style({
        image: new Icon({ src: arrowIcon, rotation }),
      }),
    PATH: new Style({
      stroke: new Stroke({ color: getCSSVariable('--tint-color'), width: 4 }),
    }),
    FENCE: new Style({
      fill: new Fill({ color: [0, 0, 0, 0.3] }),
      stroke: new Stroke({ color: 'red', width: 2 }),
    }),
  },
  ZONE: (text, color) => {
    const [r, g, b] = asArray(color);

    return new Style({
      fill: new Fill({ color: [r, g, b, 0.2] }),
      stroke: new Stroke({ color: [r, g, b], width: 2 }),
      text: new Text({
        text,
        font: 'bold 12px "Noto Sans KR", sans-serif',
        fill: new Fill({ color: [r, g, b, 0.8] }),
        stroke: new Stroke({ color: [255, 255, 255, 0.8], width: 3 }),
      }),
    });
  },
  GUIDE: {
    PATH: new Style({
      stroke: new Stroke({ color: [0, 0, 0, 0.5], width: 4 }),
    }),
    FENCE: new Style({
      fill: new Fill({ color: [0, 0, 0, 0.5] }),
      stroke: new Stroke({ color: [0, 0, 0, 0.5], width: 1 }),
    }),
    POINT: (coord, index) =>
      new Style({
        geometry: new Point(coord),
        image: new Circle({
          radius: 10,
          fill: new Fill({ color: [0, 0, 0, 0.5] }),
        }),
        text: new Text({
          text: `${index + 1}`,
          font: 'bold 9px "Noto Sans KR", sans-serif',
          fill: new Fill({ color: 'white' }),
        }),
      }),
  },
  SHOOT: {
    AREA: new Style({
      image: new Circle({
        radius: 2,
        fill: new Fill({ color: 'yellow' }),
      }),
      fill: new Fill({ color: [0, 0, 0, 0.3] }),
      stroke: new Stroke({ color: 'white', width: 1, lineDash: [2, 4] }),
    }),
    POINT: new Style({
      image: new Circle({
        radius: 6,
        fill: new Fill({ color: 'rgba(0, 0, 0, 0.6)' }),
        stroke: new Stroke({ color: 'rgba(0, 0, 0, 0.4)', width: 8 }),
      }),
    }),
  },
  SURVEY: new Style({
    fill: new Fill({ color: [0, 0, 0, 0.3] }),
    stroke: new Stroke({ color: 'black', width: 2 }),
  }),
  LINE: {
    TRACE: new Style({
      stroke: new Stroke({ color: [255, 255, 255, 0.5], width: 4 }),
    }),
    RTH: new Style({
      stroke: new Stroke({ color: [255, 255, 255, 0.8], width: 2, lineDash: [4, 8] }),
    }),
    DRAW: new Style({
      stroke: new Stroke({ color: 'black', width: 4 }),
    }),
    PATH: (color) => {
      const [r, g, b] = asArray(color);

      return new Style({
        stroke: new Stroke({ color: [r, g, b, 0.5], width: 4 }),
      });
    },
  },
};
